<template>
  <div class="mod-home">
    <el-card class="box-card">
      <div class="item">
        <b class="cardtitle">各车间产值完成一览表</b>
        <el-row :gutter="22">
          <el-col :span="24">
            <!-- :header-cell-style="{textAlign: 'center'}"
    :cell-style="{ textAlign: 'center' }"
 -->
            <el-table :data="tableData" border style="width: 100%" class="tablecenter" :summary-method="getSummaries" show-summary :cell-style="{ padding: '3px 0' }" @cell-click="handle">
              <el-table-column prop="name" label="车间" width="100">
              </el-table-column>
              <el-table-column prop="amout1" label="本年度累计产值（万元）" :formatter="stateFormat" min-width="180"></el-table-column>
              <el-table-column prop="amout2" label="本月计划产值（万元）" :formatter="stateFormat" min-width="180"></el-table-column>
              <el-table-column prop="amout3" label="本月完成产值（万元）" :formatter="stateFormat" min-width="180"></el-table-column>
              <el-table-column prop="amout4" label="产值完成率" min-width="180">
                <template slot-scope="scope">
                  {{ scope.row.amout4 }}%
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="item">
        <!-- <b class="cardtitle">PC车间产值一览表</b> -->
        <el-row :gutter="22">
          <el-col :span="24">
            <outputecharts :regBaseMom="regBaseMom" v-if="echartsif" />
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import outputecharts from "./output/output.vue";
export default {
  components: {
    outputecharts,
  },
  data() {
    return {
      regBaseMom: {
        name: "搅拌站",
        date: ["1月", "2月", "3月", "4月"],
        vcont1: [50, 20, 10, 80],
        vcont2: [150, 120, 110, 180],
      },
      echartsif: true,
      tableData: [
        {
          name: "搅拌站",
          amout1: 5220,
          amout2: 1518,
          amout3: 5220,
          amout4: 18,
        },
        {
          name: "PC车间",
          amout1: 5220,
          amout2: 1518,
          amout3: 5220,
          amout4: 18,
        },
        {
          name: "钢筋车间",
          amout1: 5220,
          amout2: 1518,
          amout3: 5220,
          amout4: 18,
        },
        {
          name: "轻体墙板",
          amout1: 5220,
          amout2: 1518,
          amout3: 5220,
          amout4: 18,
        },
      ],
    };
  },
  created() {},
  methods: {
    handle(row, column, event, cell) {
      this.regBaseMom = {};
      this.echartsif = false;
      setTimeout(() => {
        this.regBaseMom = {
          name: row.name,
          date: ["1月", "2月", "3月", "4月"],
          vcont1: [50, 20, 10, 80],
          vcont2: [150, 120, 110, 180],
        };
        this.echartsif = true;
      }, 200);
    },
    stateFormat(row, column, cellValue) {
      cellValue += "";
      if (!cellValue.includes(".")) cellValue += ".";
      return cellValue
        .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ",";
        })
        .replace(/\.$/, "");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        } else if (index === this.tableData.length) {
          sums[index] = "18%";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "N/A";
        }
      });
      const tempsum = [];
      for (var a = 0; a < sums.length; a++) {
        if (isNaN(sums[a])) {
          tempsum.push(sums[a]);
        } else {
          tempsum.push(this.interval.interval(sums[a]));
        }
      }

      return tempsum;
    },
    // 如果table数有千元分割
    //  getSummaries(param) {
    //       // console.log("---param=", param);
    //      const { columns, data } = param;
    //      const sums = [];
    //   const indexs = [this.tableData.length];

    //       columns.forEach((column, index) => {
    //         if (index === 0) {
    //           sums[index] = "合计";
    //           return;
    //         }

    //         else if (indexs.includes(index)) {
    //           sums[index] = "";
    //           return;
    //         }
    //         // console.log(data);
    //         const values = data.map((item) => Number(item[column.property]));
    //         // console.log(values);
    //         if (values.every((value) => /^(-)?([0-9]+)(\.\d{1,2})?$/.test(value))) {

    //           sums[index] = values.reduce((prev, curr) => {
    //             const value = Number(curr);
    //             if (!isNaN(value)) {
    //               return prev + curr;
    //             } else {
    //               return prev;
    //             }
    //           }, 0);
    //           sums[index] = this.stateFormat(sums[index].toFixed(2));

    //           // sums[index] += " 元";
    //         } else {
    //           sums[index] = "";
    //         }
    //       });
    //       return sums;
    //     },
  },
};
</script>

<style>
.mod-home {
  line-height: 1.5;
}
</style>

